import _ from 'lodash';
import { LOGOUT_SUCCESS } from '../actions/logout';
import api from '../api';

const PROFILE_LIST_SUCCESS = api.events.profilesList.actionSuccess;
const PROFILE_PATCH_SUCCESS = api.events.profilesPatch.actionSuccess;
const PROFILE_POST_SUCCESS = api.events.profilesPost.actionSuccess;

const defaultState = { all: [] };

export default function preferences(state = defaultState, action) {
  switch (action.type) {
    case PROFILE_POST_SUCCESS:
      return {
        ...state,
        all: [...state.all, action.data],
        lastProfileCreated: action.data
      };
    case PROFILE_PATCH_SUCCESS:
      return {
        ...state,
        all: _.map(
          state.all,
          profile => (profile.id === action.data.id ? action.data : profile)
        )
      };

    case PROFILE_LIST_SUCCESS:
      return { ...state, all: action.data };

    case LOGOUT_SUCCESS:
      return defaultState;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/profile.js